// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2076 ? "common" : chunkId) + "." + {"1036":"59d3f891","2076":"f374434e","4764":"675d2aab","8494":"ce132cf4","8726":"63bca8cd"}[chunkId] + ".chunk.css";
};